import React from 'react';
import { createContext, useContext } from 'react';
import { RefLanguage } from '../hooks/LanguageHooks';

export const I18nContext = createContext(null);

export const RefContextLanguage = () => {
    const context = useContext(I18nContext);
    if (!context) {
        throw new Error("useI18n must be used within an I18nProvider");
    }
    return context;
};



export const LanguageProvider = ({ children }) => {
    const globalI18n = RefLanguage()


    return (
        <I18nContext.Provider value={globalI18n}>
            {children}
        </I18nContext.Provider>
    );
};
